import { render } from "./ModalChangePhoto.vue?vue&type=template&id=47e0d0ba"
import script from "./ModalChangePhoto.vue?vue&type=script&lang=js"
export * from "./ModalChangePhoto.vue?vue&type=script&lang=js"

import "./ModalChangePhoto.vue?vue&type=style&index=0&id=47e0d0ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__